import { render, staticRenderFns } from "./VtLanguageSelector.vue?vue&type=template&id=748ea9b6&"
import script from "./VtLanguageSelector.vue?vue&type=script&lang=js&"
export * from "./VtLanguageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports